import { render } from "./WorkGuidanceEntry.vue?vue&type=template&id=2c3db4a0"
import script from "./WorkGuidanceEntry.vue?vue&type=script&lang=js"
export * from "./WorkGuidanceEntry.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__